<template>
  <div class="shared-detail">
    <el-row
      class="title"
      type="flex"
      align="middle"
      justify="space-between"
    >
      <h3 class="m-0">
        NỘI DUNG HIỂN THỊ TRANG BANNER: {{ page.label.toUpperCase() }}
      </h3>
    </el-row>
    <el-row class="shared-tabs">
      <el-tabs v-model="activeTab">
        <el-tab-pane
          v-for="position in listPositions"
          :key="position.id"
          :name="`${position.id}`"
        >
          <div slot="label">
            {{ `Banner ${position.id}` }}
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <page-contents
      :key="activeTab"
      :pageInfo="page"
      :position="currentPosition"
    />
    <div>
    </div>
  </div>
</template>

<script>
import PageContents from './components/Contents.vue'
const bannersJSON = require('../../../public/banners.json')

export default {
  name: 'PageDetail',
  components: {
    PageContents
  },
  data() {
    return {
      activeTab: '',
      total: 0
    }
  },
  computed: {
    page () {
      return bannersJSON.pages.find((p) => p.id === this.$route.params.id)
    },
    listPositions() {
      return this.page.positions
    },
    currentPosition() {
      return this.listPositions.find((p) => `${p.id}` === this.activeTab)
    }
  },
  beforeMount() {
    this.activeTab = `${this.listPositions[0].id}`
  }
}
</script>

<style lang="scss" scoped>
.shared-detail {
  .title {
    padding: 15px;
    background-color: #2b314a;
    color: white;
  }
  .shared-tabs {
    padding: 0 15px 15px 15px;
    background-color: #2b314a;
    color: white;
  }
}
</style>
<style lang="scss">
.shared-detail {
  .shared-tabs {
    .el-tabs__item {
      color: white;
      &:hover {
        color: #409eff;
      }
      &.is-active {
        color: #409eff;
      }
    }
  }
}
</style>
